// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__P_7tr","content":"Page_content__21_Ys","scrollingDisabled":"Page_scrollingDisabled__1YkTN"};